/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Lock_TitleInputs */

const en_explorer_info_lock_title = /** @type {(inputs: Explorer_Info_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lock Record`)
};

const fr_explorer_info_lock_title = /** @type {(inputs: Explorer_Info_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouiller l'enregistrement`)
};

const de_explorer_info_lock_title = /** @type {(inputs: Explorer_Info_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sperrdatensatz`)
};

const it_explorer_info_lock_title = /** @type {(inputs: Explorer_Info_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocca record`)
};

const ru_explorer_info_lock_title = /** @type {(inputs: Explorer_Info_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заблокировать запись`)
};

const es_explorer_info_lock_title = /** @type {(inputs: Explorer_Info_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquear registro`)
};

const zh_cn2_explorer_info_lock_title = /** @type {(inputs: Explorer_Info_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`锁定记录`)
};

const ja_explorer_info_lock_title = /** @type {(inputs: Explorer_Info_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードをロック`)
};

const hi_explorer_info_lock_title = /** @type {(inputs: Explorer_Info_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉक रिकॉर्ड`)
};

const pt_pt2_explorer_info_lock_title = /** @type {(inputs: Explorer_Info_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro de bloqueio`)
};

/**
* | output |
* | --- |
* | "Lock Record" |
*
* @param {Explorer_Info_Lock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_lock_title = /** @type {((inputs?: Explorer_Info_Lock_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Lock_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_lock_title(inputs)
	if (locale === "de") return de_explorer_info_lock_title(inputs)
	if (locale === "it") return it_explorer_info_lock_title(inputs)
	if (locale === "ru") return ru_explorer_info_lock_title(inputs)
	if (locale === "es") return es_explorer_info_lock_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_lock_title(inputs)
	if (locale === "ja") return ja_explorer_info_lock_title(inputs)
	if (locale === "hi") return hi_explorer_info_lock_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_lock_title(inputs)
	return en_explorer_info_lock_title(inputs)
});